// extracted by css-extract-rspack-plugin
export default {"cls1":"SeasonalDiscountUnibrow-cls1_kAi","cls2":"SeasonalDiscountUnibrow-cls2_lTR SeasonalDiscountUnibrow-cls1_kAi"};